import { PrincipalType } from "../../../../models/auto-generated";

export const PrincipalTypeMap = new Map<number, string>([
  [PrincipalType.SharePointUser, "SharePoint User"],
  [PrincipalType.SharePointGroup, "SharePoint Group"],
  [PrincipalType.DirectoryGroup, "Directory Group"],
  [PrincipalType.CRMUser, "Dynamics 365 User"],
  [PrincipalType.CRMTeam, "Dynamics 365 Team"]
]);
